class Utility {

    /**
     * Convert URL to Object
     *
     * @return {{}}
     */
    static getURLParams() {

        let url = window.location.href;
        let retObject = {};
        let parameters;

        if (url.indexOf('?') === -1) {

            return retObject;
        }

        url = url.split('?')[1];
        parameters = url.split('&');

        for (let i = 0; i < parameters.length; i++) {

            retObject[parameters[i].split('=')[0]] = parameters[i].split('=')[1];
        }

        return retObject;
    }

    /**
     *
     *
     * @param paramName
     * @return {*}
     */
    static getValueByParamName(paramName) {

        let value = null;
        let params = this.getURLParams();

        if (params) {

            const keys = Object.keys(params);

            for (let i = 0; i < keys.length; i++) {

                if (paramName === keys[i]) {

                    value = params[keys[i]];

                    break;
                }
            }
        }

        return value;
    }

    /**
     * Convert Array to URL
     *
     * @param array_in
     * @return {string}
     */
    static arrayToQueryString(array_in) {

        let out = [];

        for (let key in array_in) {

            out.push(key + '=' + encodeURIComponent(array_in[key]));
        }

        return out.join('&');
    }

}

module.exports = Utility;
